import _ from 'lodash';
import store from '@/store';
import { isEmptyVal } from '@/utils';
import { BILLING_CYCLE, BillingCycleEnum } from '@/common/constants';
import { translation } from '@/plugins/i18n';
import BillingMessageBox from '@/components/common/message-box';

export const validAddonCycleForBase = async () => {
  const { getSelectedPlans, getCurrentBasePlanInfo, maxCycleValueBasePlan } = store.getters;
  const { planType: basePlanType } = getCurrentBasePlanInfo;
  const basePlanCycle = maxCycleValueBasePlan?.billing_cycle;

  const checkBillingCyclePlanList = _.filter(getSelectedPlans, (p) => !isEmptyVal(p.billingCycleDependBasePlanTypeList));
  const billingCycleDependBasePlanTypeList = _.get(checkBillingCyclePlanList, [0, 'billingCycleDependBasePlanTypeList'], []);

  if (basePlanCycle && _.includes(billingCycleDependBasePlanTypeList, basePlanType) && BillingCycleEnum[basePlanCycle] < BillingCycleEnum[BILLING_CYCLE.ANNUAL]) {
    const annualAddonPlan = _.find(checkBillingCyclePlanList, (p) => p.billing_cycle === BILLING_CYCLE.ANNUAL);

    if (annualAddonPlan) {
      const addonPlanName = translation(annualAddonPlan?.typeNameKey);
      const basePlanName = translation(maxCycleValueBasePlan?.typeNameKey);

      BillingMessageBox.alert(translation('billing.error.annual_addon_disable_tooltip', [addonPlanName, basePlanName]));
      return Promise.reject();
    }
  }

  return Promise.resolve();
};
